export enum AddressDocumentTypeEnum {
    BankStatement = 'BNK',
    UtilityBill = 'BIL'
}
